









































































import { mapActions } from 'vuex';
import { filter, get, keyBy, map } from 'lodash';

import GenericCard from '@/components/cards/GenericCard.vue';
import { ModalSize } from '@/components/zen_modal/types';
import ZenSearch from '../ZenSearch.vue';
import ColumnReorder from './ColumnReorder.vue';
import SelectAllCheckbox from '@/components/zen_components/select_all_checkbox/SelectAllCheckbox.vue';

export default {
  name: 'ZenTableColumnsSettings',
  components: {
    ZenSearch,
    GenericCard,
    ColumnReorder,
    SelectAllCheckbox,
  },
  props: {
    objectType: {
      // In ModelMetaSchema.modelSingular form
      type: String,
      required: true,
    },
    activeColumns: {
      type: Array,
      required: true,
    },
    columns: {
      type: Array,
      required: true,
    },
  },
  data() {
    return {
      searchQuery: '',
      selectedColumns: [...this.activeColumns],
    };
  },
  computed: {
    highlightedColumns(): Array<string> {
      return filter(this.columns, c => c.displayName.toLowerCase().includes(this.searchQuery.toLowerCase()));
    },
    computedColumns() {
      return map(this.columns, c => ({
        ...c,
        highlight: this.highlightedColumns.includes(c),
        disabled: this.isColumnDisabled(c.name),
      }));
    },
    columnsByName() {
      return keyBy(this.columns, 'name');
    },
    colsState() {
      // TODO: refactor activeColumns to be objects
      return this.computedColumns.reduce(
        (state, col) => {
          const pushToArrays = (target, { disabled, name }) => {
            if (disabled) {
              return;
            }
            state[target].all.push(name);
            if (this.selectedColumns.includes(name)) {
              state[target].selected.push(name);
            }
          };

          if (col.isMapping) {
            pushToArrays('map', col);
          } else if (col.isCustomAttribute) {
            pushToArrays('ca', col);
          } else {
            pushToArrays('regular', col);
          }

          return state;
        },
        {
          regular: {
            all: [],
            selected: [],
          },
          ca: {
            all: [],
            selected: [],
          },
          map: {
            all: [],
            selected: [],
          },
        }
      );
    },
  },
  created() {
    this.changeModalSize(ModalSize.Large);
  },
  methods: {
    ...mapActions({
      changeModalSize: 'modals/changeSize',
      cancelModal: 'modals/cancel',
      confirmModal: 'modals/confirm',
    }),
    isColumnDisabled(attributeName: string): boolean {
      return get(this.columnsByName, [attributeName, 'sorListingPermanent'], false);
    },
    clearSearchQuery() {
      this.searchQuery = '';
    },
    reset(): void {
      this.cancelModal('columnsReset');
    },
    save(): void {
      this.confirmModal(this.selectedColumns);
    },
    onSelectAll(cols) {
      cols.forEach(c => {
        if (!this.selectedColumns.includes(c)) {
          this.selectedColumns.push(c);
        }
      });
    },
    onDeselectAll(cols) {
      this.selectedColumns = this.selectedColumns.filter(c => !cols.includes(c));
    },
  },
};
